export const TRANSLATION_SCOPE = 'tenantModule';
export const TRANSLATION_DEFAULT_SCOPE = [TRANSLATION_SCOPE, 'default'];
